export default __webpack_public_path__ + "static/media/Horiz.75ef205d.svg";